import React from 'react';
import { connect } from 'react-redux';
import {
  AxiosGetSecretApi,
  AxiosPatchSecretApi,
} from '../../../utils/fetchApi';
import MainLayout from '../../../components/Layout/MainLayout';
import { Form, Input, Select, Button, message } from 'antd';
import CustomPopconfirm from '../../../components/CustomsAntd/CustomPopconfirm';
import Card from '../../../components/Card';
import '../QuanLyTaiKhoan/quan-ly-tai-khoan.scss';
import {
  getDataLoaiPhongBan,
  getDataPhuong,
  getDataQuan,
} from '../../../redux/actions/search.action';
class EditDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      TenPhongBan: undefined,
      MoTa: undefined,
      LoaiPhongBan: undefined,
      QuanHuyen: undefined,
      PhuongXa: undefined,

      isLoading: false,

      listPhuong: this.props.listPhuong,
      listQuan: this.props.listQuan,
      listLoaiPhongBan: this.props.listLoaiPhongBan,
    };
    this.form = React.createRef();
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    if (this.props.listLoaiPhongBan.length === 0)
      this.props.getDataLoaiPhongBan();
    this.getDataPhongBan();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }

    if (prevProps.listLoaiPhongBan !== this.props.listLoaiPhongBan) {
      this.setState({ listLoaiPhongBan: this.props.listLoaiPhongBan });
    }
  }

  async getDataPhongBan() {
    let res = await AxiosGetSecretApi(
      `/api/group-user/getById?ID=${this.props.match.params.id}`
    );
    if (res && Array.isArray(res) && res.length !== 0) {
      this.form.current.setFieldsValue({
        TenPhongBan: res[0].TenPhongBan,
        MoTa: res[0].MoTa,
        LoaiPhongBan: res[0].LoaiPhongBan,
        QuanHuyen: res[0].MaQuanHuyen,
        PhuongXa: res[0].MaPhuongXa,
      });
    }
  }

  handleSubmit() {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let data = {
          TenPhongBan: e.TenPhongBan,
          MoTa: e.MoTa,
          LoaiPhongBan: e.LoaiPhongBan,
          MaQuanHuyen: e.QuanHuyen,
          MaPhuongXa: e.PhuongXa,
          MaPhongBan: this.props.match.params.id,
        };
        this.updateDepartment(data);
      })
      .catch(this.setState({ isLoading: false }));
  }

  async updateDepartment(data) {
    let res = await AxiosPatchSecretApi('/api/group-user/update', data);
    if (res && res.success) {
      message.success('Cập nhật phòng ban thành công');
      setTimeout(() => {
        this.props.history.push('/ql-nhom-nguoi-dung');
      }, 1000);
    } else {
      if (res && res.message) {
        message.error(res.message);
      } else {
        message.error('Cập nhật phòng ban không thành công');
      }
      this.setState({ isLoading: false });
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === value);

    this.setState({
      listPhuong: listPhuong,
    });
    this.form.current.setFieldsValue({
      PhuongXa: undefined,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === option.idquan);
    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN === option.idquan
    );
    this.setState({
      listPhuong: listPhuong,
    });
    this.form.current.setFieldsValue({
      QuanHuyen:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
    });
  }

  render() {
    return (
      <MainLayout {...this.props} title={'Quản lý phòng ban'}>
        <div className='page-with-card'>
          <Card title='Quản lý phòng ban'>
            <div className='create-user'>
              <div className='content'>
                <Form
                  onSubmit={this.handleSubmit}
                  style={{ width: '600px' }}
                  layout='vertical'
                  ref={this.form}
                >
                  <div className='sub-title'>Chỉnh sửa phòng ban</div>
                  <Form.Item
                    label='Tên phòng ban'
                    style={{ marginBottom: '18px' }}
                    name='TenPhongBan'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập tên phòng ban!',
                      },
                      {
                        message: 'Vui lòng kiểm tra lại tên phòng ban!',
                        pattern: new RegExp(
                          '^[a-zA-Z0-9]([._](?![._])|[a-zA-Z0-9]){0,50}[a-zA-Z0-9]$',
                          'g'
                        ),
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className='input' />
                  </Form.Item>

                  <Form.Item
                    label='Mô tả'
                    style={{ marginBottom: '18px' }}
                    name='MoTa'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập mô tả!',
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className='input' />
                  </Form.Item>

                  <Form.Item
                    label='Loại phòng ban'
                    style={{ marginBottom: '18px' }}
                    name='LoaiPhongBan'
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng chọn loại phòng ban!',
                      },
                    ]}
                  >
                    <Select className='select'>
                      {this.state.listLoaiPhongBan.map((e, i) => (
                        <Select.Option value={e.value} key={i}>
                          {e.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label='Quận/ Huyện'
                    style={{ marginBottom: '18px' }}
                    name='QuanHuyen'
                    hasFeedback
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "Vui lòng phòng Quận/Huyện !",
                        // },
                      ]
                    }
                  >
                    <Select
                      className='select'
                      onChange={(value) => this.onChangeQuan(value)}
                    >
                      {this.state.listQuan.map((e, i) => (
                        <Select.Option value={e.MAHUYEN} key={i}>
                          {e.TENHUYEN}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label='Phường/ Xã'
                    style={{ marginBottom: '18px' }}
                    name='PhuongXa'
                    hasFeedback
                    // rules={[
                    //   { required: true, message: "Vui lòng Phường/Xã !" },
                    // ]}
                  >
                    <Select
                      className='select'
                      onChange={(value, option) =>
                        this.onChangePhuong(value, option)
                      }
                    >
                      {this.state.listPhuong.map((e, i) => (
                        <Select.Option
                          value={e.MaPhuong}
                          idquan={e.MaQuan}
                          key={i}
                        >
                          {e.TenPhuong}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <CustomPopconfirm
                    title={'Bạn có chắc muốn cập nhật?'}
                    okText='Có'
                    cancelText='Không'
                    content={
                      <div
                        style={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <Button
                          className='button-create-user'
                          loading={this.state.isLoading}
                          onClick={() => {}}
                          type='primary'
                        >
                          Cập nhật
                        </Button>
                      </div>
                    }
                    onConfirm={(e) => this.handleSubmit(e)}
                  />
                </Form>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
    listLoaiPhongBan: state.search.listLoaiPhongBan,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
  getDataLoaiPhongBan: getDataLoaiPhongBan,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDepartment);
